export const scrollToStartOfDiv = (
  ref: React.RefObject<HTMLDivElement>,
  offsetInPx?: number
) => {
  if (!ref.current) return;

  if (offsetInPx) {
    const elementRect = ref.current.getBoundingClientRect();
    const elementTop = elementRect.top;
    const adjustedScrollTop = elementTop + window.pageYOffset - offsetInPx;

    // Scrolling to the adjusted position
    window.scrollTo({ top: adjustedScrollTop, behavior: 'smooth' });
  } else ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
